import './ChartNoData.scss';

export const ChartNoData = () => (
	<div className="ChartNoData">No data for selected period</div>
);
